import { DataLayer } from "@grandvisionhq/analytics";
import { ProductAnalyticsEvents } from "@grandvisionhq/fun-products";
import { getVariantFacetName } from "../../../DataLayer/utils.js";
const pushPowerSelectionEvent = (event, eventLabel) => {
  DataLayer.pushEvent({
    event,
    eventAction: "plp select lens power",
    eventLabel
  });
};
const pushVariantClickEvent = (selectedVariant, productType) => {
  const sku = selectedVariant.sku;
  if (productType === "Ready-readers") {
    const selectedPower = selectedVariant.power;
    const eventLabel = `${sku} | ${selectedPower}`;
    selectedPower ? pushPowerSelectionEvent("readyreaders", eventLabel) : null;
  }
  const variantFacet = getVariantFacetName(selectedVariant, productType);
  if (productType && variantFacet) {
    ProductAnalyticsEvents.pushPlpVariantClickEvent({
      type: productType,
      id: sku,
      name: `${selectedVariant.brand.name} ${selectedVariant.name}`,
      dimension147: variantFacet
    });
  }
};
export {
  pushPowerSelectionEvent,
  pushVariantClickEvent
};
//# sourceMappingURL=VariantSwitcherEvents.js.map
